'use es6';

const HEX_CODE_REGEX = new RegExp('^#([A-Fa-f0-9]{2})([A-Fa-f0-9]{2})([A-Fa-f0-9]{2})|^#([A-Fa-f0-9]{1})([A-Fa-f0-9]{1})([A-Fa-f0-9]{1})$');
export default HEX_CODE_REGEX;